<template>
  <div class="dialog-container wt-dialog-container">
    <div v-loading="isUserIntegralDetailsDetailLoading">
      <wt-form-table :form.sync="form" @on-button-action="onButtonAction" >
        <wt-form-table-list slot="wtFormTableList" :form.sync="form">
          <template slot="type" slot-scope="data">
            <!-- <span>{{ data.row.type === 10 ? data.row.remark : $wtConst.integralType[data.row.type] }}</span> -->
            <span>{{ $wtConst.integralType[data.row.type] }}</span>
          </template>
          <template slot="integral" slot-scope="data">
            <span style="color: #F56C6C;" v-if="[8, 12, 16, 17, 21, 22, 23].indexOf(data.row.type) > -1">{{ '-' + data.row.integral }}</span>
            <span style="color: #67C23A;" v-else>{{ '+' + data.row.integral }}</span>
          </template>
          <!-- <template slot="otherInformation" slot-scope="data">
            <span v-if="data.row.type == 23 || data.row.type == 24">{{ (data.row.type == 23 ? '被赠送用户：' : '赠送用户：') + data.row.otherInformation }}</span>
          </template> -->
        </wt-form-table-list>
      </wt-form-table>
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'UserIntegralDetails-view',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    return {
      formCode: 'MODULES_USERINTEGRALDETAILS',
      isSubmitLoading: false,
      formUpdateUrl: '/modules/userIntegralDetails/userIntegralDetailsUpdate',
      formAddUrl: '/modules/userIntegralDetails/userIntegralDetailsAdd',
      detailFormButtons: {
        title: '详情',
        elements: [{ name: '创建', key: 'ADD', action: 'ADD', hidden: this.componentType !== 'add' },
          { name: '保存', key: 'EDIT', action: 'EDIT', hidden: this.componentType !== 'edit' },
          { name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      },
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULES_USERINTEGRALDETAILS',
        formComponent: {
          list: { type: 'default', value: '/modules/userIntegralDetails/userIntegralDetailsList' }
        },
        formInputsData: [{ name: '搜索用户', key: 'userId', value: '', type: 'customAll' }],
        formButtonsData: [{ name: '导出Excel',
          key: 'EXPORT',
          action: 'EXCEL',
          hidden: false,
          url: window.wtConst.BASE_API + '/modules/userIntegralDetails/userIntegralDetailsListImport',
          fileName: '用户积分' }],
        formTableData: [
          { name: '积分详情', key: 'type', type: 'custom' },
          { name: '时间', key: 'createTime', type: 'text', sortable: 'custom' },
          { name: '积分', key: 'integral', type: 'custom' },
          { name: '对方信息', key: 'otherInformation', type: 'text' },
          { name: '理由', key: 'remark', type: 'text' },
          { name: '站点', key: 'siteName', type: 'text', sortable: 'custom' }],
        formTableButtonsData: [],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true, searchButtonHidden: true, buttonHidden: true }
      }
    }
  },
  created() {
    this.form.formInputsData[0].value = this.detailFormData.id
  },
  methods: {
    /*  ------------------------- 按钮  -------------------------  */
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
      }
    },
    onButtonAction() {

    },
    /*  ------------------------- 网络请求  -------------------------  */
    onWtDialogClose() {
      this.$emit('on-dialog-action', 'close')
    }
  },
  computed: {
    ...mapState({
      isUserIntegralDetailsDetailLoading: state => state.userIntegralDetails.isUserIntegralDetailsDetailLoading,
      detailFormData: state => state.userIntegralDetails.userIntegralDetailsDetailData
    })
  }
}
</script>

<style scoped>

</style>
